module.exports = __webpack_public_path__ + "static/media/poll.0f560b81.svg";